import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
const Index = (props) => {
  const dispatch = useDispatch()
  const { appReducer } = useSelector(state => state);
  const navigate = useNavigate();
  return (

    <div className='w-100 d-flex justify-content-between align-items-center p-2 zIndex-10'>
      <button className='text-white w-50 bg-unset border-unset d-flex justify-content-between align-items-start' onClick={() => {
        navigate(routeLink.HISTORY)
      }}>Historys   {">"} </button>
      {/* <span className='text-white w-50 text-end'>Level <span className='fw-bold'>2/10</span></span> */}
      <div className='ssssdassa'>
        <button className='ppppsadddd22asd mr-2' style={{ marginRight: 10 }} onClick={() => {
          navigate(routeLink.DEPOSIT)
        }}>
          Deposit
        </button>
        <button className='ppppsadddd22asd' onClick={() => {
          navigate(routeLink.WITHDRAW)
        }}>
          Withdraw
        </button>
      </div>
    </div>
  )
}

export default Index;
